/* Site-Specific JavaScript */
var pubsYearFilter = jq('#publications-year-filter');
var applyBtn = jq('#apply-filters');
var clearBtn = jq('#clear-filters');

if (pubsYearFilter.length) {
    applyBtn.accessibleClick(function(event) {
        event.preventDefault();
        jq('.module-publications .content-box').removeClass('hide');
        var year = jq(pubsYearFilter).val();
        if (year == '-1') {
            return;    
        }
        jq('.module-publications .content-box').each(function() {
            var box = jq(this);
            var boxYear = box.data('year');
            if (boxYear != year) {
                box.addClass('hide');    
            }
        });
    });
    clearBtn.accessibleClick(function(event) {
        event.preventDefault();
        jq('.module-publications .content-box').removeClass('hide');
        pubsYearFilter.val('Default');
        pubsYearFilter.selectpicker("refresh");
    });
}